(function() {
  const stickyBanner = document.querySelector('.sticky-add-to-cart-banner');
  if (!stickyBanner) return;

  // querySelector throws on an empty or invalid selector, so treat those as "not found"
  const safeQuery = (selector) => {
    if (!selector || !selector.trim()) return null;
    try {
      return document.querySelector(selector);
    } catch (e) {
      return null;
    }
  };

  const scrollTarget = stickyBanner.getAttribute('data-scroll-target');
  const chooseOptionsButton = stickyBanner.querySelector('.sticky-add-to-cart-banner__button[data-scroll-target]');

  // Add scroll functionality to choose options button
  if (chooseOptionsButton) {
    chooseOptionsButton.addEventListener('click', function() {
      // scroll to the product options (the buy box title), below the site header; scrollTo needs a number, not the element
      const productOptionsElement = document.querySelector('.product-buy-box__title') || safeQuery(chooseOptionsButton.getAttribute('data-scroll-target'));
      if (productOptionsElement) {
        const header = document.querySelector('.header');
        const offset = (header ? header.offsetHeight : 0) + 16;
        window.scrollTo({
          top: Math.max(0, productOptionsElement.getBoundingClientRect().top + window.pageYOffset - offset),
          behavior: 'smooth'
        });
      }
    });
  }

  // Show/hide banner based on scroll position
  const targetElement = safeQuery(scrollTarget);
  if (targetElement) {
    const handleScroll = () => {
      const targetRect = targetElement.getBoundingClientRect();

      // Show banner when the target element is above the viewport
      if (targetRect.bottom < 0) {
        stickyBanner.classList.add('sticky-add-to-cart-banner--visible');
      } else {
        stickyBanner.classList.remove('sticky-add-to-cart-banner--visible');
      }
    };

    // Initial check
    handleScroll();

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll, { passive: true });
  }
})();
